import { render, staticRenderFns } from "./ContactUsDetails.vue?vue&type=template&id=258bce44&scoped=true&"
import script from "./ContactUsDetails.vue?vue&type=script&lang=js&"
export * from "./ContactUsDetails.vue?vue&type=script&lang=js&"
import style0 from "./ContactUsDetails.vue?vue&type=style&index=0&id=258bce44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258bce44",
  null
  
)

export default component.exports